import Skeleton from '@/app/components/feedback/Skeleton';

const ReportPageSkeleton = () => (
  <section aria-busy="true" aria-label="Carregando relatório" className="app-container container-xxl">
    <output className="visually-hidden">Carregando relatório...</output>
    <div aria-hidden="true" className="d-flex flex-column gap-5 px-3 px-lg-9 mt-5">
      <div className="card card-flush border shadow-none">
        <div className="card-body py-5 fw-bold">Como usar este relatório</div>
      </div>
      <div className="card card-flush border shadow-none">
        <div className="card-body">
          <h3 className="card-title mb-10">Filtros</h3>
          <div className="row g-5 mb-5">
            {[0, 1, 2].map((fieldNumber) => (
              <div key={fieldNumber} className="col-12 col-md-4">
                <Skeleton className="mb-3" height={14} width="40%" />
                <Skeleton height={42} />
              </div>
            ))}
          </div>
          <div className="d-flex justify-content-end">
            <span className="btn btn-primary disabled">Gerar relatório</span>
          </div>
        </div>
      </div>
      <div className="card card-flush border shadow-none">
        <div className="card-body">
          <Skeleton height={300} />
        </div>
      </div>
    </div>
  </section>
);

export default ReportPageSkeleton;
